<div class="flex flex-1 flex-wrap items-start justify-between gap-4">

    <div class="min-w-0">
        <div class="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
            <h3 class="text-md font-semibold text-primary">
                {{ briefName() }}
            </h3>
            <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset bg-sky-50 dark:bg-sky-900/30 text-sky-700 ring-sky-600 ring-opacity-20">Screening brief</span>
        </div>
        <p class="mt-0 text-xs text-secondary">Manage Screening Brief</p>
    </div>

    <div class="flex shrink-0 flex-wrap items-center gap-2.5">
        <!-- <button type="button" [attr.aria-disabled]="true"
            class="secondary-button inline-flex cursor-not-allowed items-center gap-2 opacity-60">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" x2="12" y1="15" y2="3" />
            </svg>
            Export report
            <span
                class="rounded-full bg-muted px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-muted-foreground">Soon</span>
            <span class="sr-only">— CSV export is coming soon</span>
        </button> -->

        <!-- <button type="button" class="primary-button inline-flex items-center gap-2" (click)="onAddCreators()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" x2="19" y1="8" y2="14" />
                <line x1="22" x2="16" y1="11" y2="11" />
            </svg>
            Add creators
        </button> -->
    </div>
</div>